import { IconButton, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import RefreshIcon from "@mui/icons-material/Refresh";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useSelector } from "react-redux";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import AccountSummeryCategorySortBy from "./AccountSummeryCategorySortBy";
import { sitePerformanceAll } from "../../../../../../../../../AssetManagement/Overview/BusinessLeaderDashboard/AdditionalQueries/AdditionalQueriesAccordion/AdditionalQueriesConstants";
import {
  colors,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";

const AccountSummeryCategoryFilter = ({
  sortConfig,
  setSortConfig,
  onRefresh,
}: any) => {
  const { loadingOverviewAccountSummaryData, overviewAccountSummaryData } =
    useSelector((state: any) => state.bizDevelopmentDashboardMobile);

  const brandCount = overviewAccountSummaryData?.query_output?.length || 0;
  const tableHeadingsAll = sitePerformanceAll;

  const getRowCSV = (col: any, row: any) => {
    if (row[col?.key] === null) {
      return "null";
    } else if (col?.key === "date") {
      if (row?.date) {
        return `${row?.day} ${dayjs(row?.date).format("DD-MM-YYYY")}`;
      } else if (row?.month) {
        return row?.month;
      } else if (row?.start_of_week) {
        return row?.start_of_week;
      }
    } else if (
      col?.label === "CVR%" ||
      col?.label === "% RS From Total Income" ||
      col?.key === "roi_perc" ||
      col?.key === "ng_ftd_br_ftd"
    ) {
      let value = row[col?.key] * 100;
      value = Math.round(value);
      return value + "%";
    } else if (
      row[col?.key] !== 0 &&
      col?.key !== "date" &&
      col?.key !== "br_ftd" &&
      col?.key !== "ng_ftd" &&
      col?.key !== "qftds" &&
      col?.key !== "qftds" &&
      col?.key !== "click_in" &&
      col?.key !== "click_out"
    ) {
      let value = Math.round(row[col?.key]);
      return value + "$";
    } else {
      return row[col?.key];
    }
  };

  const handleExportCSV = () => {
    const csvRows = [];
    const headers = tableHeadingsAll.map((pair) => pair.key) as any;
    csvRows.push(headers.join(","));
    // eslint-disable-next-line
    overviewAccountSummaryData?.query_output?.map((row: any) => {
      let rowData = [] as any;
      // eslint-disable-next-line
      tableHeadingsAll.map((key: any) => {
        const result = getRowCSV(key, row);
        if (result !== "null") {
          rowData.push(result);
        }
      });
      if (rowData?.length > 0) {
        csvRows.push(rowData.join(","));
      }
    });
    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "SitePerformance.csv");
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ color: colors.GrayLightMode[900].$value }}
      >
        <Typography
          display={"flex"}
          alignItems={"center"}
          flexDirection={"row"}
          gap={1}
          sx={{
            fontSize: typography.Size.Text.xs.$value,
            fontWeight: typography.Font_weight.Regular.$value,
          }}
        >
          Sort by:
          <AccountSummeryCategorySortBy
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
          />
        </Typography>
        <Stack direction="row" alignItems="center">
          <IconButton
            color="secondary"
            size="large"
            disabled={loadingOverviewAccountSummaryData}
            onClick={handleExportCSV}
            data-tracker="848"
          >
            <FileDownloadIcon
              sx={{ color: colors.GrayLightMode[700].$value }}
            />
          </IconButton>
          <IconButton
            color="secondary"
            size="large"
            edge="end"
            onClick={onRefresh}
            disabled={loadingOverviewAccountSummaryData}
            data-tracker="849"
          >
            <RefreshIcon sx={{ color: colors.GrayLightMode[700].$value }} />
          </IconButton>
        </Stack>
      </Stack>
      <Typography
        mb={2}
        sx={{
          fontSize: typography.Size.Text.xs.$value,
          fontWeight: typography.Font_weight.Regular.$value,
          color: colors.GrayLightMode[700].$value,
        }}
      >
        <Box
          component="span"
          sx={{ fontWeight: typography.Font_weight.Medium.$value }}
        >
          {brandCount}
        </Box>{" "}
        Brands
      </Typography>
    </>
  );
};

export default AccountSummeryCategoryFilter;
